import React, { ComponentProps } from "react";

type TDecorationImageProps = ComponentProps<"img"> & {
  containerClassName?: string;
  inlineMargin?: number;
  max?: number;
  maxHeight?: number;
};
export default function DecorationImage({
  containerClassName = "",
  inlineMargin = 15,
  max = 200,
  maxHeight = 400,
  className = "",
  alt = "image",
  ...props
}: TDecorationImageProps) {
  return (
    <div
      className={`flex-center ${containerClassName}`}
    >
      <img
        alt={`decoration ${alt}`}
        className={`mx-auto animation-fade-in block w-100 ${className}`}
        style={{ maxWidth: `min(calc(100% - ${inlineMargin}rem), ${max}px)`, maxHeight: `min(50vh, ${maxHeight}px)` }}
        {...props}
      />
    </div>
  );
}
